export default "__VITE_ASSET__hBmn2PO4__"